import http from "../http";

const FIRsService = {

    GetFIRsService: async () => {
        const firs = await http.instance.get("/FIRs");
        return firs.data
    },

    AddFIRService: async (form) => {
        const fir = await http.instance.post("/FIRs/Add", form)
        return fir.data;
    },

    UpdateFIRService: async (form) => {
        const updatefir = await http.instance.post("/FIRs/Edit", form)
        return updatefir.data;
    },

    DeleteFIRService : async (form) => {
        const deletedfir = await http.instance.post("/FIRs/Delete", form)
        return deletedfir.data;
    },

    GetCountry: async () => {
        const country = await http.instance.get("/FIRs/GetCountries")
        return country.data;
    },

    getNotamImportantWordList_service: async ()=> {

        const resp = await http.instance.get("/FIRs/GetNotamImportantWords")
        console.log(resp.data)
        return resp.data;
    },

    addNotamImportantWordList_service : async (notamimportant) =>{
        const resp = await http.instance.post("/FIRs/AddNotamImportantWord", notamimportant)
        return resp.data;
    },

    editNotamImportantWordList_service : async (notamimportant) => {
        const resp = await http.instance.post("/FIRs/EditNotamImportantWord", notamimportant)
        return resp.data;
    },

    deleteNotamImportantWordList_service: async (notamimportant) => {
        const resp = await http.instance.post("/FIRs/DeleteNotamImportantWord",notamimportant)
        console.log(resp.data + "çalıştı...")
        return resp.data;

    }



};
export default FIRsService;
